import type StateInline from "markdown-it/lib/rules_inline/state_inline";
import type MarkdownIt from "markdown-it";

type MarkdownItWithMention = MarkdownIt & { __mentionPluginApplied?: boolean };

const MENTION_SYNTAX = /^@\[((?:[^\]\\]|\\.)+)\]\(([^)]+)\)/;

export const addMentionMarkdownPlugin = (markdownit: MarkdownIt) => {
    const md: MarkdownItWithMention = markdownit;
    if (md.__mentionPluginApplied) {
        return;
    }

    const mentionRule = (state: StateInline, silent: boolean) => {
        const start = state.pos;
        const max = state.posMax;

        const match = state.src.slice(start, max).match(MENTION_SYNTAX);
        if (!match) {
            return false;
        }

        const label = match[1].trim();
        const id = match[2].trim();
        if (!label || !id) {
            return false;
        }

        if (!silent) {
            const token = state.push("unifiedMention", "", 0);
            token.attrs = [
                ["id", id],
                ["label", label],
            ];
        }

        state.pos += match[0].length;
        return true;
    };

    md.inline.ruler.before("link", "unifiedMention", mentionRule);

    md.renderer.rules.unifiedMention = (tokens: MarkdownIt.Token[], idx: number) => {
        const token = tokens[idx];
        const id = token.attrGet("id") || "";
        const label = token.attrGet("label") || id;
        return `<span class="mention" data-type="mention" data-id="${id}" data-label="${label}">@${label}</span>`;
    };

    md.__mentionPluginApplied = true;
};
